import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    disabled;
    confidence;
    type;
    ruleForm = {
        confidenceValue: this.$props.confidence,
    };
    get rules() {
        return {
            confidenceValue: [
                { required: true, message: `${this.$t('thresholdInputRule')}`, trigger: 'blur' },
                { pattern: this.getPattern(), message: this.inputPlaceholder, trigger: 'blur' },
            ],
        };
    }
    getPattern() {
        let newTime = /^([1-9]\d?|100)$/;
        switch (String(this.type)) {
            case 'vehicleNumber':
                newTime = /^([1-9]|[1-9]\d|[1-9]\d\d)$/;
                break;
            default:
                newTime = /^([1-9]\d?|100)$/;
        }
        return newTime;
    }
    get inputPlaceholder() {
        // if (this.type === 'vehicleNumber') {
        //   return this.$t('vehicleInputRule');
        // } else {
        return this.$t('thresholdInputRule');
        // }
    }
    changeName(val) {
        this.$emit('update:confidence', val);
    }
    isValidate() {
        let isValidate = null;
        this.$refs.ruleForm.validate((valid) => {
            if (valid) {
                isValidate = true;
            }
            else {
                isValidate = false;
            }
        });
        return isValidate;
    }
    getType() {
        let icon = '%';
        switch (String(this.type)) {
            case 'vehicleNumber':
                icon = '';
                break;
            default:
                icon = '%';
        }
        return icon;
    }
};
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
__decorate([
    Prop()
], default_1.prototype, "confidence", void 0);
__decorate([
    Prop()
], default_1.prototype, "type", void 0);
default_1 = __decorate([
    Component({
        name: 'SingleConfidence',
        components: {},
        i18n: {
            messages: {
                zh: {
                    thresholdInputRule: '请输入匹配度阈值，1-100',
                    ideal: '推荐值',
                },
                en: {
                    thresholdInputRule: 'Please enter matching rate, 1-100',
                    ideal: 'Ideal',
                },
            },
        },
    })
], default_1);
export default default_1;
